var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-sum"},[_vm._m(0),_c('div',{staticClass:"bar-chart-holder"},[_c('BarChart',{attrs:{"item-data":_vm.itemData,"label":"Active passengers","width":500,"height":150}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',[_vm._v(" Active Passengers: "),_c('span',[_vm._v("3 months")])])
}]

export { render, staticRenderFns }